"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NSeeder__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "ProbabilitiesLocked",
        type: "event",
    },
    {
        inputs: [],
        name: "accTypeCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "areProbabilitiesLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "cAccCountProbability",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "cSkinProbability",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "cTypeProbability",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "punkId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "salt",
                type: "uint256",
            },
        ],
        name: "generateSeed",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "punkType",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "skinTone",
                        type: "uint8",
                    },
                    {
                        components: [
                            {
                                internalType: "uint16",
                                name: "accType",
                                type: "uint16",
                            },
                            {
                                internalType: "uint16",
                                name: "accId",
                                type: "uint16",
                            },
                        ],
                        internalType: "struct ISeeder.Accessory[]",
                        name: "accessories",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct ISeeder.Seed",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "pseudorandomness",
                type: "uint256",
            },
        ],
        name: "generateSeedFromNumber",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "punkType",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "skinTone",
                        type: "uint8",
                    },
                    {
                        components: [
                            {
                                internalType: "uint16",
                                name: "accType",
                                type: "uint16",
                            },
                            {
                                internalType: "uint16",
                                name: "accId",
                                type: "uint16",
                            },
                        ],
                        internalType: "struct ISeeder.Accessory[]",
                        name: "accessories",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct ISeeder.Seed",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockProbabilities",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "punkType",
                type: "uint16",
            },
            {
                internalType: "uint256[]",
                name: "probabilities",
                type: "uint256[]",
            },
        ],
        name: "setAccCountProbability",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "_accExclusion",
                type: "uint256[]",
            },
        ],
        name: "setAccExclusion",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[][][]",
                name: "accIds",
                type: "uint256[][][]",
            },
            {
                internalType: "uint256[][][]",
                name: "accWeights",
                type: "uint256[][][]",
            },
        ],
        name: "setAccIdByType",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "punkType",
                type: "uint16",
            },
            {
                internalType: "uint256[]",
                name: "probabilities",
                type: "uint256[]",
            },
        ],
        name: "setSkinProbability",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "probabilities",
                type: "uint256[]",
            },
        ],
        name: "setTypeProbability",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NSeeder__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NSeeder__factory = NSeeder__factory;
NSeeder__factory.bytecode = _bytecode;
NSeeder__factory.abi = _abi;
